import { Moment } from "moment";
import { DateRange, DateActiveType, StrictDateRange } from "./type";


export const cloneDateRange = <T extends DateRange>(dateRange: T): T => {
    return {
        start: dateRange.start?.clone(),
        end: dateRange.end?.clone()
    } as T;
};

export const getDateRangeInDayOrder = (date1: Moment, date2: Moment) => {
    return date1.isBefore(date2, 'day')
        ? { start: date1, end: date2 }
        : { start: date2, end: date1 };
};

export const getDateActiveType = (date: Moment, range: DateRange): DateActiveType => {
    const { start, end } = range;

    if (!date.isBetween(start, end, 'day', '[]')) {
        return "not_active";
    }
    const isStart = date.isSame(start, 'day');
    const isEnd = date.isSame(end, 'day');

    if (isStart && isEnd) {
        return "start_end";
    } else if (isStart) {
        return "start";
    } else if (isEnd) {
        return "end";
    } else {
        return "between";
    }
};

export const DATE_FORMAT = "YYYY.MM.DD";

export const adjustSameMonth = (months: StrictDateRange, strategy: 'forward' | 'backward') => {
    if (months.start.isBefore(months.end, 'months')) {
        return months;
    }

    const monthsClone = cloneDateRange(months);
    if (strategy === 'forward') {
        monthsClone.end = monthsClone.start.clone().add(1, 'months');
    } else {
        monthsClone.start = monthsClone.end.clone().subtract(1, 'months');
    }
    return monthsClone;
};

export const dateRangeInvalidCause = (dateRange: DateRange, max: number | undefined): string | undefined => {
    const { start, end } = dateRange;
    if (!start || !end) {
        return "required";
    }
    const diff = Math.floor(end.diff(start, 'day', true));
    if (max && diff > max) {
        return "max";
    } else if (start.isSameOrAfter(end)) {
        return "invalid_range";
    }
    return;
};
